<template>
  <div class="w-full mx-auto top-0 mb-20 relative" v-if="user">
    <dashboard-heading :name="user.name" :photo="user.urlProfilePhoto" />
    <div class="flex min-h-screen flex-col md:flex-row">
      <dashboard-menu id="menu" class="md:hidden flex font-bold text-2xl px-10 h-20 z-40 shadow
        bg-white justify-between fixed bottom-0 shadowColorMobile w-screen" />
      <section class="flex pb-24 w-full px-4 lg:px-20 z-10 bg-white border-2 pt-10">
        <dashboard-menu id="menu" class="hidden md:flex md:flex-col font-bold text-2xl
        px-6 lg:px-8 py-16 h-auto
        bg-white justify-between md:justify-start border-2 shadow" />
        <div class="flex flex-col w-full pl-0 md:pl-10">
          <profile-nav :dashboardPath="dashboardPath" :profilePic="user.urlProfilePhoto" />
          <router-view></router-view>
        </div>
      </section>

      <div v-if="$router.currentRoute.path === '/dashboard'">
        <div class="flex justify-center flex-col md:flex-row w-1/2 md:w-full
          mx-auto mt-20 lg:mt-0"
          v-if="false">

          <div class="mt-20 flex justify-center items-center px-20"
            v-if="!this.user.timezone || !this.user.student">
              <dashboard-button
                @click="chooseTimezone"
                :buttonPlaceholder="$t('dashboard.complete')"
                class="mt-4 md:mt-0 text-red-600" />

              <modal resizable name="timezone" />
          </div>
          <div v-else class="flex flex-col">
            <student-experience :student="user.student" />
            <student-data :student="user.student" />
          </div>
        </div>

        <div class="flex justify-center mt-10 w-5/6 mx-auto">
          <next-booked-lessons
            :slots="checkedBookedSlots"
            :title="$t('bookedLessonsDashboard.title')"
            :isStudent="true"
            @startLesson="payLesson($event)" />
        </div>
      </div>
    </div>
    <!-- <div v-else class="flex justify-start">
      <router-link to="/dashboard" id="container" class="hover:text-beige-academy-300">
        <div class="flex justify-start items-center pl-12 mx-auto pb-10 lg:pb-0 group">
          <img :src="user.urlProfilePhoto" alt="foto profilo" id="photo"
            class="rounded-full mr-4 w-16 border-4 border-white transform group-hover:scale-105
            group-hover:border-blue-academy-300">
          <h1 class="font-bold text-3xl hover:border-white
            transform group-hover:scale-105"
            id="title">{{user.student.name}}</h1>
        </div>

      </router-link>
    </div>
    -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import dayjs from 'dayjs';
// import Heading from '@/components/Heading.vue';
import DashboardButton from '@/components/DashboardButton.vue';
import TimezoneForm from '@/components/TimezoneForm.vue';
import StudentExperience from '@/components/students/StudentExperience.vue';
import StudentData from '@/components/students/StudentData.vue';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import DatesConversion from '@/mixins/DatesConversion';
// import { getStudentStripeDefaultPaymentMethod } from '@/services/PaymentService';
import NextBookedLessons from '../components/NextBookedLessons.vue';
import DashboardHeading from '../components/graphics/DashboardHeading.vue';
import ProfileNav from '../components/graphics/ProfileNav.vue';
import DashboardMenu from '../components/graphics/DashboardMenu.vue';

export default {
  data() {
    return {
      bookedSlots: [],
    };
  },

  components: {
    DashboardButton,
    StudentExperience,
    StudentData,
    NextBookedLessons,
    DashboardHeading,
    ProfileNav,
    DashboardMenu,
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
      student: 'auth/student',
      dashboardPath: 'auth/dashboardPath',
    }),
    checkedBookedSlots() {
      return this.checkSlotsTimeToMakeButtonAppear(this.bookedSlots);
    },
  },

  watch: {
    choosenTimezone() {
      this.bookedSlots = [];
      if (this.user) {
        this.getBookedLessons();
      }
    },
  },

  mounted() {
    if (this.user) this.getBookedLessons();
  },

  mixins: [StreamFunctionsMixin, DatesConversion],

  methods: {
    chooseTimezone() {
      this.$modal.show(TimezoneForm, {}, {
        adaptive: true, resizable: true, height: 'auto',
      });
    },

    getBookedLessons() {
      const now = dayjs.utc();
      now.subtract(15, 'm');
      const startDate = this.changeDateFormatForCalendarAndDatabase(now);
      return axios.get(`/api/students/${this.user.student.id}/lessons?startDate=${startDate}`)
        .then((response) => {
          response.data.forEach((slot) => {
            if (slot.status === 'booked') {
              const newSlot = this.convertBookedSlotToBePrintedOnDashboard(slot, 'student');
              newSlot.lesson = slot.lesson;
              if (!this.bookedSlots.some(
                (existingSlot) => existingSlot.startDate === newSlot.startDate,
              )) {
                this.bookedSlots.push(newSlot);
              }
            }
          });
        }).catch((errors) => {
          console.log(`Lettura slots prenotati fallita: ${errors}`);
        });
    },

    payLesson(slot) {
      axios.post(`/api/lessons/${slot.booking_id}/payment`)
        .then((response) => {
          if (this.paymentMethod === 'paypal') {
            this.loadPaypal(response.data);
            return;
          }
          if (this.paymentMethod === 'card' && response.data.error) {
            this.checkTheErrorType(response.data, slot);
            return;
          }
          this.startLesson(slot);
        }).catch(() => {
          this.createNotification('error', `${this.$t('notifications.errorPayment')}`);
        });
    },

    startLesson(slot) {
      axios.get(`/api/lesson/${slot.booking_id}/get-url?for=student`).then(({ data }) => {
        window.location.href = data;
      }).catch((errors) => {
        console.log(errors);
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .shadowColorMobile {
    --tw-shadow: 0 10px 15px 3px rgb(0, 0, 0),
      0 10px 6px 2px rgb(77, 71, 71);
      box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(235, 98, 98, 0)),
      var(--tw-ring-shadow, 0 0 rgba(243, 93, 93, 0)), var(--tw-shadow);
  }
  .shadowColor {
    --tw-shadow: 0 10px 10px -3px rgb(0, 0, 0),
      0 0px 6px -2px rgb(77, 71, 71);
      box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(235, 98, 98, 0)),
      var(--tw-ring-shadow, 0 0 rgba(243, 93, 93, 0)), var(--tw-shadow);
  }
  .tooltip {
    @apply invisible absolute text-gray-500 text-xs mt-10 font-sans-serif;
  }

  .has-tooltip:hover .tooltip {
    @apply visible z-50;
  }
</style>
